import { PATTERN_CEP } from './shared/constants';
import applyNumberMask from './shared/apply-number-mask';

export default function cep(value) {
  const pattern = PATTERN_CEP;
  return applyNumberMask({ value, pattern });
}
